export default __webpack_public_path__ + "static/media/home-icon-sustainable.e890d488.png";